import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  InitiatePaymentRequest,
  InitiatePaymentResponse,
  PaymentMethod,
} from '../types/payment.types';
import { Transaction } from '../types/transaction.types';

/**
 * Client payment-service. Couvre :
 *   - listing des méthodes de paiement actives (Wave / Orange Money / Free Money)
 *   - initiation d'un paiement (recharge wallet, paiement facture, etc.)
 *
 * L'enveloppe de réponse `/api/transactions/initiate` n'est PAS l'enveloppe
 * Nawam : c'est directement le {@link InitiatePaymentResponse}. Idem pour
 * {@code /api/payment-methods} qui retourne un `List<PaymentMethod>` brut.
 */
@Injectable({ providedIn: 'root' })
export class PaymentsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/payment/api`;

  /**
   * Méthodes actives — `GET /api/payment-methods`. On **exclut `CASH`**
   * (`serviceCode === 'CASH'`) : le paiement espèces n'est pas une option
   * dans les flux digitaux (paiement facture, recharge) côté front.
   */
  listActiveMethods(): Observable<PaymentMethod[]> {
    return this.http
      .get<PaymentMethod[]>(`${this.base}/payment-methods`)
      .pipe(map((list) => (list ?? []).filter((m) => m.serviceCode !== 'CASH')));
  }

  /** Initie un paiement GUTouch (toutes les actions front passent par ici). */
  initiate(body: InitiatePaymentRequest): Observable<InitiatePaymentResponse> {
    return this.http.post<InitiatePaymentResponse>(
      `${this.base}/transactions/initiate`,
      body,
    );
  }

  /**
   * Récupère une transaction par son id. Utilisé par `PaymentResultComponent`
   * pour poller le statut tant que le callback GUTouch n'est pas encore
   * arrivé (status=PENDING dans la query, transactionStatus=INITIATED en BD).
   */
  getTransaction(id: number): Observable<Transaction> {
    return this.http.get<Transaction>(`${this.base}/transactions/${id}`);
  }
}
